// token是否过期
import Cookie from 'js-cookie';
import Api from '../API';
import store from '../store';

export const SSO_CREDENTIALS_KEY = 'ruijienetworks_sso_internal_certificate';
export const USER_CREDENTIALS_KEY = 'ruijienetworks_user_credentials';
export const PARTNERS_TOKEN = 'partners_token';
export const PARTNERS_TOKEN_COOKIE_CERT = 'partners_token_cookie_cert';
export const PARTNERS_TOKEN_EXPIRED_TIME = 'partners_token_expired_time';

// 检验Token是否有过期 如果不存在Token 直接默认过期
export const validateTokenExpired = () => {
  const token = Cookie.get(PARTNERS_TOKEN);
  if (!token) return false;
  const expiresTime = Number(Cookie.get(PARTNERS_TOKEN_EXPIRED_TIME) || 0);
  // 没有过期时间 直接当作过期
  return expiresTime ? expiresTime > new Date().getTime() : false;
};

// 是否有对应的登录cookie
export const validateCookieCert = () => !!(Cookie.get(SSO_CREDENTIALS_KEY) || Cookie.get(USER_CREDENTIALS_KEY));

// 校验cookie是否和token对应的cookie相等
export const validateTokenCookie = () => {
  const cookieCertificate = getCookieCertificate();
  if (!cookieCertificate) return false;
  const tokenCookieCert = Cookie.get(PARTNERS_TOKEN_COOKIE_CERT, { path: '/', domain: '.ruijienetworks.com' });
  // token 对应的cookie 凭证
  return cookieCertificate.value === tokenCookieCert;
};

// 获取cookie登录信息
const getCookieCertificate = () => {
  if (Cookie.get(SSO_CREDENTIALS_KEY)) {
    return {
      key: SSO_CREDENTIALS_KEY,
      value: Cookie.get(SSO_CREDENTIALS_KEY)
    };
  } else if (Cookie.get(USER_CREDENTIALS_KEY)) {
    return {
      key: USER_CREDENTIALS_KEY,
      value: Cookie.get(USER_CREDENTIALS_KEY)
    };
  }
};

// 刷新Token
const refreshToken = async () => {
  const cookieCertificate = getCookieCertificate();
  try {
    const { data: { data: { token, expiresDate } }, status } = await Api.postGenerate(cookieCertificate);
    if (Number(status) === 200) {
      // 这里的过期时间expires 不作为token是否过期的依据， 唯一的依据为 expiresDate
      Cookie.set(PARTNERS_TOKEN, token, { path: '/', domain: '.ruijienetworks.com', expires: 2 });
      Cookie.set(PARTNERS_TOKEN_EXPIRED_TIME, expiresDate, { path: '/', domain: '.ruijienetworks.com', expires: 2 });
      Cookie.set(PARTNERS_TOKEN_COOKIE_CERT, cookieCertificate.value, { path: '/', domain: '.ruijienetworks.com', expires: 2 });
      store.dispatch('GET_USER');
    }
  } catch (e) {
    console.log(e);
  }
};

// 清空所有关联的Cookie
export const removeAllCookie = () => {
  Cookie.remove(PARTNERS_TOKEN, { path: '/', domain: '.ruijienetworks.com' });
  Cookie.remove(USER_CREDENTIALS_KEY, { path: '/', domain: '.ruijienetworks.com' });
  Cookie.remove(SSO_CREDENTIALS_KEY, { path: '/', domain: '.ruijienetworks.com' });
  Cookie.remove(PARTNERS_TOKEN_COOKIE_CERT, { path: '/', domain: '.ruijienetworks.com' });
  Cookie.remove(PARTNERS_TOKEN_EXPIRED_TIME, { path: '/', domain: '.ruijienetworks.com' });
};

export const toLogin = () => {
  window.location.href = `https://www.ruijienetworks.com/login.aspx?r=${encodeURIComponent(window.location.href)}`;
};
export const logOut = () => {
  removeAllCookie();
  toLogin();
};
// axios处处理Token的函数
export const handleAxiosAndRouterToken = async () => {
  if (validateCookieCert()) { // 是否有Cookie
    // token 是否有效 有效不做任何操作
    if (!validateTokenExpired() || !validateTokenCookie()) { // 无效刷新Token
      await refreshToken();
    }
  } else {
    removeAllCookie();
    toLogin();
  }
};
